/* global VideoPlayer */

/**
 * JW Player support for magnific popup
 */

// Create a contained object instead of global variables
var currentJwplayer = (function() {
    var self = {
        setCurrentPlayer(player) {
            this.player = player;
        },
        setCurrentPlayerElement(playerElement) {
            this.playerElement = playerElement;
        },
        getCurrentPlayer() {
            return this.player;
        },
        getCurrentPlayerElement() {
            return this.playerElement;
        }
    };

    return {
        setCurrentPlayer: self.setCurrentPlayer,
        setCurrentPlayerElement: self.setCurrentPlayerElement,
        getCurrentPlayer: self.getCurrentPlayer,
        getCurrentPlayerElement: self.getCurrentPlayerElement
    };
})();

$.magnificPopup.registerModule('jwplayer', {
    options: {
        markup:
            '<div class="mfp-jw-wrapper">' +
            '<button type="button" class="mfp-close">&times;</button>' +
            '<div id="mfp-jwplayer"></div>' +
            '</div>'
    },

    proto: {
        initJwplayer: function() {},

        // getElementId: function(element) {
        //     // Correlate clicked button to the right one in the DOM
        //     var buttons = document.querySelectorAll('.btn-play');
        //     var elementButton = element.querySelector('.btn-play') || element;
        //     for (var index = 0; index < buttons.length; index++) {
        //         if (buttons[index] === elementButton) {
        //             return index;
        //         }
        //     }
        // },

        setupClonedButton: function(element) {
            currentJwplayer.setCurrentPlayerElement(element);

            // Create a dupe since this gets removed by the Platform Video Player
            var buttonClone = currentJwplayer.getCurrentPlayerElement().cloneNode(true);
            var parentToAddTo = currentJwplayer.getCurrentPlayerElement().parentNode;

            // Put the button copy where the removed button was
            parentToAddTo.appendChild(buttonClone);

            // Set new cloned button to be the player element
            currentJwplayer.setCurrentPlayerElement(buttonClone);
        },

        instantiatePlayer: function() {
            var urlHref = currentJwplayer.getCurrentPlayerElement().getAttribute('href');
            var urlHls = currentJwplayer
                .getCurrentPlayerElement()
                .getAttribute('data-video-url-hls');
            var urlProg = currentJwplayer
                .getCurrentPlayerElement()
                .getAttribute('data-video-url-progressive');
            if (!(urlHref || urlHls || urlProg)) {
                return;
            }
            var player = new VideoPlayer(currentJwplayer.getCurrentPlayerElement(), {
                url: currentJwplayer.getCurrentPlayerElement().getAttribute('href')
            });
            currentJwplayer.setCurrentPlayer(player);
        },

        appendPlayerToPopup: function() {
            if (!currentJwplayer.getCurrentPlayer()) {
                return;
            }
            var playerElement = document.querySelector(
                '#' + currentJwplayer.getCurrentPlayer().element.id
            );
            document.querySelector('#mfp-jwplayer').appendChild(playerElement);
        },

        getJwplayer: function(item, template) {
            this.updateStatus('ready');
            var isDone = false;

            this.ev.on('mfpOpen', function() {
                // Setup video and make sure it only does it once
                if (!isDone) {
                    var clickedElement = item.el[0];

                    $.magnificPopup.proto.setupClonedButton(clickedElement);
                    $.magnificPopup.proto.instantiatePlayer();
                    $.magnificPopup.proto.appendPlayerToPopup();

                    if (!currentJwplayer.getCurrentPlayer()) {
                        return;
                    }

                    // Finish and play video
                    currentJwplayer.getCurrentPlayer().play();
                    isDone = true;
                }
            });

            this.ev.on('mfpBeforeClose', function() {
                var currentPlayer = currentJwplayer.getCurrentPlayer();

                currentPlayer.destroy();
            });

            return template;
        }
    }
});

function uglyJwplayerWrapperHack() {
    var videoObj = $('.jw-video-popup');
    var jwChildWithPop = videoObj.find($('.jw-video-popup'));
    if (jwChildWithPop.length > 0) {
        jwChildWithPop.removeClass('jw-video-popup');
    }
}

uglyJwplayerWrapperHack();

// Add to jQuery (oe) prototype – without this the popup will not display, instead just going to a fullscreen video (normal, but unwanted behavior)
// If the class here is changed, the modal will not work
$('.jw-video-popup').magnificPopup({
    type: 'jwplayer'
});
